<template>
  <v-card class="card-shadow border-radius-xl pa-6">
    <v-row>
      <v-col cols="6">
        <div class="pb-4">
          <h6 class="mb-1 text-typo text-h6 font-weight-bold">
            Liste des attributs
          </h6>
          <p class="text-sm text-body">
            Ajouter, supprimer ou modifier des attributs
          </p>
        </div>
      </v-col>
      <v-col cols="4">
        <SearchField @search="searchUpdate"></SearchField>
      </v-col>
      <v-col cols="2">
        <v-dialog v-model="dialog" width="400" class="overwrite-dropzone-index">
          <template v-slot:activator="{ on, attrs }">
            <BtnBlue
              :btnTitle="$t('appButton.add')"
              v-bind="attrs"
              v-on="on"
              @clicked="dialog = !dialog"
            ></BtnBlue>
          </template>
          <ClientAttributesCreate
            :editAttribut="selectedItem"
            :key="dialog"
            @closeDialog="dialog = false"
          ></ClientAttributesCreate>
        </v-dialog>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-data-table
      :headers="headers"
      fixed-header
      height="70vh"
      :items="filteredData"
      class="table"
      hide-default-footer
      mobile-breakpoint="0"
      :items-per-page="filteredData.length"
    >
      <template v-slot:[`item.name`]="{ item }">
        <p class="text-sm font-weight-bold mt-4 mb-0">
          {{ item.name || "n/c" }}
        </p>
      </template>
      <template v-slot:[`item.weight`]="{ item }">
        <p class="text-sm font-weight-bold mt-4 mb-0">
          {{ item.weight }}
        </p>
      </template>
      <template v-slot:[`item.isVehicle`]="{ item }">
        <p class="text-sm font-weight-bold mt-4 mb-0">
          {{ item.isVehicle ? "oui" : "non" }}
        </p>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon size="18" class="text-typo mr-4" @click="editAttribut(item)"
          >mdi mdi-pen</v-icon
        >
        <v-icon size="18" class="text-typo" @click="preventDelete(item)"
          >mdi mdi-delete</v-icon
        >
      </template>
    </v-data-table>
    <PreventDelete
      :dialogDelete="dialogDelete"
      :itemToDelete="itemToDelete"
      :loading="loading"
      @abort="abortDelete"
      @confirm="deleteAttribut"
    ></PreventDelete>
  </v-card>
</template>

<script>
import SearchField from "../common/SearchField.vue";
import PreventDelete from "../common/PreventDelete.vue";
import BtnBlue from "../common/BtnBlue.vue";

import ClientAttributesCreate from "./ClientAttributesCreate.vue";

export default {
  name: "ClientAttributes",

  components: {
    SearchField,
    BtnBlue,
    ClientAttributesCreate,
    PreventDelete,
  },

  data() {
    return {
      search: "",
      dialog: false,
      loading: false,
      dialogDelete: false,
      itemToDelete: null,
      headers: [
        {
          text: "Nom",
          value: "name",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Poids",
          value: "weight",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Attribuable à un véhicule",
          value: "isVehicle",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "",
          value: "action",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7",
        },
      ],
      selectedItem: null,
    };
  },

  computed: {
    attributes() {
      return this.$store.getters.attributes;
    },

    filteredData() {
      const dataToScan = ["name", "weight"];
      if (this.search === "") return this.attributes;
      return this.attributes.filter((elm) => {
        return dataToScan.some((k) => {
          const search = this.search.toLowerCase();
          return elm[k] && String(elm[k]).toLowerCase().includes(search);
        });
      });
    },
  },

  watch: {
    dialog(nVal) {
      if (!nVal) {
        this.selectedItem = null;
      }
    },
  },

  methods: {
    searchUpdate(e) {
      this.search = e;
    },

    editAttribut(item) {
      this.selectedItem = item;
      this.dialog = true;
    },

    preventDelete(item) {
      this.dialogDelete = true;
      this.itemToDelete = item;
    },

    abortDelete() {
      this.itemToDelete = null;
      this.dialogDelete = false;
    },

    async deleteAttribut(item) {
      this.loading = true;
      await this.$store.dispatch("delete_attributes", item.id);
      this.loading = false;
      this.dialogDelete = false;
    },
  },
};
</script>

<style scoped></style>
